import React, { Component } from 'react';
import { Menu } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
const SubMenu = Menu.SubMenu;

class Sider extends Component {

    constructor(props) {
        super(props);
        let current = '';
        this.state = {
            current,
            isShowInvPlan: false,
        };
    }

    componentWillReceiveProps(){
        this.setState({
            current: location.hash.substr(1)
        })
    }

    componentWillMount(){
        this.setState({
            current: location.hash.substr(1)
        })
        this.queryBlindInvestigation();
    }

    handleClick = e => {
        this.setState({
            current: e.key,
        });
    }

    queryBlindInvestigation = () => {
        const options = {
            method: 'POST',
            url: API_URL.plan.queryBlindInvestigation,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { isBlind, secondLines } = res;
                const isShowInvPlan = isBlind && secondLines === '非盲';
                this.setState({
                    isShowInvPlan,
                });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { isShowInvPlan } = this.state;
        const { invState, blindType } = sessionStorage;
        const isTotal = invState == 1;
        const isConcrete = invState == 2;
        const isConfig = invState == 3;
        const isUnBlind = blindType === 'NOTBLIND';       // 非盲项目
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                >
                    {
                        !isUnBlind ?
                            <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe639;</i><span>项目计划</span></span>}>
                                {
                                    !isConcrete && <Menu.Item key="/plan/degree">
                                        <a href="#/plan/degree">项目阶段进度计划</a>
                                    </Menu.Item>
                                }
                                {
                                    isTotal && <Menu.Item key="/plan/invStart">
                                        <a href="#/plan/invStart">项目启动计划</a>
                                    </Menu.Item>
                                }
                                {
                                    <Menu.Item key="/plan/siteStart">
                                        <a href="#/plan/siteStart">{!isConcrete ? '各' : ''}中心启动计划</a>
                                    </Menu.Item>
                                }
                                {
                                    !isConcrete && <Menu.Item key="/plan/investigation">
                                        <a href="#/plan/investigation">项目执行计划</a>
                                    </Menu.Item>
                                }
                                <Menu.Item key="/plan/site">
                                    <a href="#/plan/site">{!isConcrete ? '各' : ''}中心执行计划</a>
                                </Menu.Item>
                                {
                                    !isConfig &&
                                    <Menu.Item key="/plan/siteFte">
                                        <a href="#/plan/siteFte">{!isConcrete ? '各' : ''}中心FTE计划</a>
                                    </Menu.Item>
                                }
                                {
                                    isTotal &&
                                    <Menu.Item key="/plan/PmFte">
                                        <a href="#/plan/PmFte">PM-FTE计划</a>
                                    </Menu.Item>
                                }
                                {
                                    isTotal &&
                                    <Menu.Item key="/plan/PAFte">
                                        <a href="#/plan/PAFte">PA-FTE计划</a>
                                    </Menu.Item>
                                }
                            </SubMenu>
                        :
                            <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe639;</i><span>项目计划</span></span>}>
                                {
                                    (isTotal && isShowInvPlan) && <Menu.Item key="/plan/investigation">
                                        <a href="#/plan/investigation">项目执行计划</a>
                                    </Menu.Item>
                                }
                                {
                                    (isTotal && isShowInvPlan) && <Menu.Item key="/plan/site">
                                        <a href="#/plan/site">各中心执行计划</a>
                                    </Menu.Item>
                                }
                                <Menu.Item key="/plan/siteFte">
                                    <a href="#/plan/siteFte">{!isConcrete ? '各' : ''}中心FTE计划</a>
                                </Menu.Item>
                                {
                                    isTotal &&
                                    <Menu.Item key="/plan/PmFte">
                                        <a href="#/plan/PmFte">PM-FTE计划</a>
                                    </Menu.Item>
                                }
                                {
                                    isTotal &&
                                    <Menu.Item key="/plan/PAFte">
                                        <a href="#/plan/PAFte">PA-FTE计划</a>
                                    </Menu.Item>
                                }
                            </SubMenu>
                    }
                </Menu>
            </aside>
        );
    }
}

export default Sider;



// WEBPACK FOOTER //
// ./src/components/plan/PlanSider.js